//https://www.smashingmagazine.com/2020/10/authentication-in-vue-js/
import Vuex from "vuex"
import Vue from "vue"
import createPersistedState from "vuex-persistedstate"
import auth from "./modules/auth"
import classes from "./modules/classes"
import reservations from "./modules/reservations"
import kidsReservations from "./modules/kidsReservations"
import alerts from "./modules/alerts"
import tutors from "./modules/tutors"
import filters from "./modules/filters"
import tutorDetails from "./modules/tutorDetails"
import dashboardDrawer from "./modules/dashboardDrawer"
import courses from "./modules/courses"
import sessionReservation from "./modules/sessionReservation"
import notifications from "./modules/notifications"
// Load Vuex
Vue.use(Vuex)
// Create store
export default new Vuex.Store({
  modules: {
    auth,
    classes,
    reservations,
    kidsReservations,
    alerts,
    tutors,
    filters,
    tutorDetails,
    dashboardDrawer,
    courses,
    sessionReservation,
    notifications,
  },
  plugins: [createPersistedState()],
})
